import { Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, NgForm } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { Observable } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { getCheckboxField, getExitTemplateSelectField, getSelectField, setAsDisabledWhen, setAsRequired } from 'src/app/shared/form/form-utils';
import { isNullOrUndefined } from '../../app/core/utils';
import { DEFAULT_INLINE_TMPL_EDITOR_TOOLBAR_CONFIG, DEFAULT_TMPL_EDITOR_TOOLBAR_CONFIG, ToastService } from '../core';
import { EmailApi, EmailAttachments, EmailMessage, EmailTemplate, ExitApi, ExitMailTemplateInfo, HttpStatusCode, LookupField } from '../core/api.gen';
import { AttachmentUploadService } from '../core/attachment-upload.service';
import { AuthService } from '../core/auth.service';
import { CommonService } from '../core/common.service';
import { DialogService } from '../core/dialog.service';
import { DocumentUploadService } from '../core/document-upload.service';
import { LoaderService } from '../core/loader.service';
import { LookupTypeKeys } from '../shared/lookup-type-keys';
import { nullSafe } from '../utils';

@Component({
  selector: 'eos-exit-template-generator',
  templateUrl: './exit-template-generator.component.html',
  styleUrls: ['./exit-template-generator.component.css']
})
export class ExitTemplateGeneratorComponent implements OnInit {

  templates$: Observable<EmailTemplate[]>;
  exitType$: Observable<LookupField[]>;
  exitSubTypes$: Observable<LookupField[]>;
  officeLocation$: Observable<LookupField[]>;
  nationalityType$: Observable<LookupField[]>;
  form = new UntypedFormGroup({});
  model: any = {};
  options: FormlyFormOptions = {};
  fields: FormlyFieldConfig[];
  emailMessage: EmailMessage = new EmailMessage();
  fileDetails: EmailAttachments;
  selectedDocument: File;
  isDisabled = false;

  @ViewChild('fileField', { static: true }) element: ElementRef;
  @ViewChild('fileControl', { static: true }) fileEle: ElementRef;
  @ViewChild('f', { static: true }) forms: NgForm;

  disableUpload = false;
  uploadedFiles: EmailAttachments[] = [];




  readonly allowedMineTypes = [
    'application/pdf'
    , 'image/jpeg'
    , 'image/png'
    , 'application/msword'
    , 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    , 'application/vnd.ms-excel'
    , 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ];
  readonly MAX_FILE_SIZE: number = 10 * 1024 * 1024;
  readonly MIN_FILE_SIZE: number = 1 * 1024;


  toolbarConfig = { ...DEFAULT_TMPL_EDITOR_TOOLBAR_CONFIG };

  inlineToolbarConfig = { ...DEFAULT_INLINE_TMPL_EDITOR_TOOLBAR_CONFIG };
  exitRequestId: any;

  constructor(
    private emailApi: EmailApi,
    private exitApi: ExitApi,
    private common: CommonService,
    private loader: LoaderService,
    private toast: ToastService,
    public authService: AuthService,
    private location: Location,
    private documentUploadService: DocumentUploadService,
    private attachmentUploadService: AttachmentUploadService,
    private dialog: DialogService) { }

  ngOnInit() {
    this.initForm();
  }




  initForm() {
    this.exitType$ = this.common.prepareLookupObservable(LookupTypeKeys.EXIT_TYPES);
    this.exitSubTypes$ = this.common.prepareLookupObservable(
      LookupTypeKeys.EXIT_SUBTYPES
    );
    this.officeLocation$ = this.common.prepareLookupObservable(LookupTypeKeys.OFFICE_LOCATION);
    this.nationalityType$ = this.common.prepareLookupObservable(LookupTypeKeys.ONBOARDING_TYPES);
    this.model = { showSysTemplates: false };
    this.fileDetails = new EmailAttachments();
    this.initFormFields();
  }
  resetModel(showSys: boolean) {
    this.model = { showSysTemplates: showSys };
  }

  back() {
    this.location.back();
  }

  initFormFields() {
    this.fields = [
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
          getCheckboxField("showSysTemplates", 'Show system templates', (x) => this.resetModel(x)),

        ],
      },

      {
        fieldGroupClassName: 'row',
        fieldGroup: [

          getSelectField(
            "exitType.id",
            "Exit type", this.common.getSelectFieldOptions(this.exitType$.pipe(map(item => item.filter(i => [10859, 10860,13395].includes(i.id)))), '', setAsRequired())
          ),
          getSelectField(
            "officeLocation.id",
            "Office Location", this.common.getSelectFieldOptions(this.officeLocation$.pipe(map(item => item.filter(i => ![
            ].includes(i.id)))), '', setAsRequired(setAsDisabledWhen((x) => x.showSysTemplates)))
          ),

          getSelectField(
            "exitSubType.id",
            "Exit sub type", this.common.getSelectFieldOptions(this.exitSubTypes$.pipe(map(item => item.filter(i => ![10916].includes(i.id)))), "exitType.id", setAsDisabledWhen((x) => x.showSysTemplates))
          ),

          getSelectField(
            "nationalityType.id",
            "Nationality Type", this.common.getSelectFieldOptions(this.nationalityType$, '', setAsDisabledWhen((x) => x.showSysTemplates))
          ),
          getExitTemplateSelectField(
            "exitEmailTemplateinfo",
            "Template", this.common.getExitEmailTemplateSelectFieldOptions((x) => this.onTemplateSelected(x), setAsRequired())
          ),
        ],
      },
    ];
  }

  onTemplateSelected(template: ExitMailTemplateInfo) {
    this.LoadTemplateContent(template);
  }
  LoadTemplateContent(template: ExitMailTemplateInfo) {
    if (template && template.id > 0) {
      this.loader.show();
      this.emailApi.getEmailMessage(template.id, false).pipe(
        finalize(() => this.loader.clear())
      ).subscribe(em => {
        this.emailMessage = em;
        this.getUploadedAttachmentDetails(template.id);
      }, err => {
        this.toast.error('Error occured while loading the template');
        this.emailMessage = new EmailMessage();
      });
    } else {
      this.emailMessage = new EmailMessage();
      this.uploadedFiles = [];
    }
  }

  onSave() {
    if (nullSafe(() => this.emailMessage.activityTemplateId, -1) > 0) {
      this.loader.show();
      this.emailApi.saveEmailTemplate(this.emailMessage)
        .pipe(finalize(() => this.loader.clear()))
        .subscribe(result => {
          //this.form.reset();
          if (result.statusCode == HttpStatusCode.Created) {
            let templateObj = new ExitMailTemplateInfo();
            templateObj.id = !isNullOrUndefined(this.emailMessage.activityTemplateId) ? this.emailMessage.activityTemplateId : 0;
            this.LoadTemplateContent(templateObj);
            this.toast.success("Template updated successfully");
            this.form.markAsPristine();
          }
        }, err => {
          this.toast.error("Something went wrong!");
        });
    }
  }
  submit() {
    return;
  }

  sendMe() {

    if (!this.exitRequestId) {
      this.toast.warning("Please input an Exit ID");
    }
    else if (!this.emailMessage.templateCode) {
      this.toast.warning('Please select an email template');
    }
    else {
      this.exitApi.isExitReqExists(this.exitRequestId).subscribe(x => {
        if (x == true) {
          this.loader.show();
          this.emailApi.getExitRenderedMail(this.exitRequestId, this.emailMessage.templateCode, this.emailMessage.activityTemplateId)
            .pipe(finalize(() => this.loader.clear()))
            .subscribe(emailMessage => {
              this.dialog.loadGenMail(emailMessage, (mail) => { this.sendAsync(mail) }, 'Preview',()=>this.uploadedtemplate(
                emailMessage.activityTemplateId
              ));
            });
        }
        else {
          this.toast.warning("Please input a valid ID");
        }
      });
    }
  }
  uploadedtemplate(templateId:number)
  {
      return this.emailApi.getAttachmentsNewDetails(templateId);
  }
  sendAsync(mail): void {
    this.loader.show();
    this.emailApi.sendExitPreview(this.exitRequestId, mail)
      .pipe(finalize(() => this.loader.clear()))
      .subscribe(x => { });
  }
  get ifDocNotValid(): boolean {
    if (this.selectedDocument && (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE)) {
      return true;
    }

    return false;
  }

  browseFile() {
    // console.log(this.fileEle);
    this.fileEle.nativeElement.click();
  }

  get fileBrowserAllowedTypes() {
    return this.allowedMineTypes.join(',');
  }

  fileSelected(files: FileList) {
    // console.log(files);
    if (!files.item(0)) {
      return;
    }
    this.selectedDocument = files.item(0);

    if (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE) {

      this.toast.error(`Invalid file size. File size should be between ${(this.MIN_FILE_SIZE / 1024).toFixed()} KB
		   and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);

      this.fileEle.nativeElement.value = null;
      return;
    }


    if (this.allowedMineTypes.indexOf(this.selectedDocument.type) < 0) {
      this.toast.error(`Invalid file type. Please select a valid file`);
      this.fileEle.nativeElement.value = null;
      this.selectedDocument = null;
      this.element.nativeElement.value = "";
      return;
    }

    this.fileDetails.fileName = this.selectedDocument.name;
  }

  get selectedFileName(): string {
    return nullSafe(() => this.selectedDocument.name, '');
  }
  uploadDoc(f: NgForm) {


    if (f.invalid) {
      return;
    }

    if (this.ifDocNotValid) {
      this.toast.error(`Invalid file size. File size should be between ${(this.MIN_FILE_SIZE / 1024).toFixed()}
		   KB and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);
      return;
    }
    if (isNullOrUndefined(this.selectedDocument)) {
      this.toast.warning("Please select a file!");
      return;
    }
    // if (this.allFiles.some((item) => (item.fileName === this.fileDetails.fileName) && (item.id !== this.fileDetails.id))) {
    if (this.uploadedFiles.some((item) => (item.fileName === this.selectedDocument.name) && (item.id !== this.fileDetails.id))) {
      this.toast.error("Attachment Name should be unique");
      return;
    }
    // if (this.form.value.showSysTemplates) {
    //   this.fileDetails.emailTemplateId = this.form.value.emailTemplateinfoSysTemp.id;
    // } else {
    this.fileDetails.emailTemplateId = this.emailMessage.activityTemplateId;
    // }



    this.fileDetails.createdById = this.authService.ActiveUser.employeeId;
    this.upload(f);
  }
  upload(f: NgForm) {
    f.form.disable();
    this.disableUpload = true;
    this.isDisabled = true;
    this.attachmentUploadService.postFileTemplate(this.fileDetails, this.selectedDocument).pipe(finalize(() => {
      this.selectedDocument = null;
      this.fileEle.nativeElement.value = null;
      f.form.enable();
      this.disableUpload = false;
      this.isDisabled = false;
      // f.reset({});
    }))
      .subscribe(resp => {
        // this.updateAllFiles(resp.data);
        this.element.nativeElement.value = "";
        this.toast.success("File uploaded successfully!");
        this.getUploadedAttachmentDetails(this.fileDetails.emailTemplateId);

        //this.getUploadedAttachmentDetails(this.candidate_Id, this.activity.id, this.results.activityTemplateId);
      }, error => {
        this.toast.error("Something went wrong!");
      });
    // this.GetDocumentEvent.emit(this.uploadedFiles);
  }
  getUploadedAttachmentDetails(emailTemplateId: number) {
    this.emailApi.getAttachmentsNewDetails(emailTemplateId).subscribe(resp => {
      this.uploadedFiles = resp;
    });
  }

  removeAttachment(id) {
    this.emailMessage.attachments.splice(this.emailMessage.attachments.indexOf(id), 1);
  }
  deleteAttachment(fileDetails) {
    this.emailApi.deleteAttachment(fileDetails).subscribe((resp) => {
      this.toast.success("Attachment deleted!");
      this.uploadedFiles = resp;
    });
  }

  downloadFile(fileName: string) {
    this.documentUploadService.downloadDocumentFile(fileName);
  }

  downloadAttachment(details) {
    this.attachmentUploadService.downloadAttachment(details);
  }

  initiateSaveToMany(f: NgForm) {
     if (f.invalid) {
      this.toast.error("Only semicolon seperation is allowed and usage of seperation at the beginning is restricted in the To,CC and BCC Field.");
      return;
    }
    this.dialog.showTemplateDialog(this.emailMessage, this.form.controls.exitEmailTemplateinfo.value);
  }
}
